import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Row, Card, Button, ListGroup, ListGroupItem, Col } from "react-bootstrap";

export default function View() {
	const [data, setData] = useState([]);
	const [extra, setExtra] = useState([]);
	const here = useLocation();

	useEffect(() => {
		setData(JSON.parse(JSON.stringify(here.state.info)));
		setExtra(JSON.parse(JSON.stringify(here.state.info[11])));
	}, []);

	return (
		<div>
			<Card
				className="text-center"
				style={{
					marginTop: "30px",
					marginBottom: "40px",
					marginLeft: "auto",
					marginRight: "auto",
					width: "400px",
					boxShadow: "0px 4px 10px",
				}}
			>
				<Card.Header></Card.Header>
				<Card.Body>
					<ListGroup className="list-group-flush">
						<ListGroupItem><b>Claim ID </b>: {data[0]}</ListGroupItem>
						<ListGroupItem><b>Patient Name </b>: {extra[0]}</ListGroupItem>
						<ListGroupItem><b>Patient Age </b>: {extra[1]}</ListGroupItem>
						<ListGroupItem><b>Patient Sex </b>: {extra[2]}</ListGroupItem>
						<ListGroupItem><b>Cost </b>: {data[1]}</ListGroupItem>
						<ListGroupItem><b>Admin Sign</b> : {data[2] ? "YES" : "NO"}</ListGroupItem>
						<ListGroupItem><b>Insurance Sign </b>: {data[3] ? "YES" : "NO"}</ListGroupItem>
						<ListGroupItem><b>Ailment</b> : {data[4]}</ListGroupItem>
						<ListGroupItem><b>Date</b> : {data[5]}</ListGroupItem>
						<ListGroupItem><b>Hospital Name </b>: {data[6]}</ListGroupItem>
						<ListGroupItem><b>Patient Address</b>: {data[7]}</ListGroupItem>
						<ListGroupItem><b>Admin Address</b>: {data[8]}</ListGroupItem>
						<ListGroupItem><b>Insurance provider address</b> : {data[9]}</ListGroupItem>
						<ListGroupItem><b>IPFS Hash</b> : {data[10]}</ListGroupItem>
					</ListGroup>
				</Card.Body>
				<Card.Footer className="text-muted"></Card.Footer>
			</Card>
		</div>
	);
}
